import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { forwardRef, type ButtonHTMLAttributes } from 'react'
import SvgPlus from '@jotta/ui/SvgPlus'
import styles from './Fab.module.scss'
import clsx from 'clsx'

export interface FabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  open?: boolean
}

export const Fab = forwardRef<HTMLButtonElement, FabProps>(function Fab(
  { open, className, ...props }: FabProps,
  ref,
) {
  return (
    <button
      className={clsx(
        clsx(styles.fab, '!bg-btn-primary !text-btn-primary-text', className),
      )}
      data-open={open}
      {...props}
      ref={ref}
    >
      <PlainBrandIcon icon={SvgPlus} />
    </button>
  )
})
